"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const IconRenderer_1 = tslib_1.__importDefault(require("../renderers/IconRenderer"));
const index_1 = require("../index");
class IconColumnConfig extends index_1.ColumnConfig {
    constructor(args) {
        super({
            ...args,
            clickable: false,
            mapDataToTDCssClasses: () => [index_1.TDCssClasses.ICON],
            sortable: false
        });
        this.renderer = new IconRenderer_1.default();
    }
}
exports.default = IconColumnConfig;
//# sourceMappingURL=IconColumnConfig.js.map